module.exports = __webpack_public_path__ + "static/media/route.47e2bbd6.svg";